import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var SelectDown = function SelectDown(props) {
  useDeprecatedComponentWarning({
    component: 'SelectDown'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M5.942 8h12.116c.838 0 1.257 1.02.664 1.618l-6.056 6.104a.939.939 0 01-1.332 0L5.278 9.619C4.685 9.02 5.104 8 5.942 8z"
  }));
};

SelectDown.displayName = 'SelectDown';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  SelectDown.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default SelectDown;